import HorizontalLineUi from 'common/components/entities/HorizontalLine/HorizontalLineUi'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import React from 'react'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import BaseEntityNew from '../core/BaseEntity/BaseEntityNew'

type HorizontalLineProps = {
  entity: HorizontalLineInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function NewHorizontalLine({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: HorizontalLineProps) {
  const { miscellaneous } = useThemeColor()
  const globalDividerColor = miscellaneous?.dividersColor
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <HorizontalLineUi
        id={entity.htmlAttrId}
        border={{
          ...entity.border,
          color: entity.border?.color || globalDividerColor,
        }}
        mobileBorder={{
          ...entity.mobileBorder,
          color: entity.mobileBorder?.color || globalDividerColor,
        }}
      />
    </BaseEntityNew>
  )
}
export default NewHorizontalLine
